import React from 'react';
import PropTypes from 'prop-types';
import { PremiumChatDesktop, PremiumExclusiveDesktop, PremiumMedicalDesktop } from "@/icons";
import {
  Dental,
  ExclusiveRewards,
  Family,
  Lab,
  MedicalDiscounts,
  Pharmacy,
  Telemedicine,
  Vision,
  WholeFamily,
} from "@/icons/premium";

const ICONS = {
  ExclusiveRewards,
  Family,
  MedicalDiscounts,
  WholeFamily,
  chat: PremiumChatDesktop,
  dental: Dental,
  exclusive: PremiumExclusiveDesktop,
  lab: Lab,
  medical: PremiumMedicalDesktop,
  prescriptions: Pharmacy,
  telemedicine: Telemedicine,
  vision: Vision,
};

export default function IconComponent({ name }) {
  const Icon = ICONS[name];

  return <Icon />;
}

IconComponent.propTypes = {
  name: PropTypes.string.isRequired,
};
